import { render, staticRenderFns } from "./InventoryItemSelect.vue?vue&type=template&id=2a495dc0&"
import script from "./InventoryItemSelect.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports